import { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import { Colors, Icon, Text } from '@mercator-gcp/grout';

const linkStyle = {
  display: 'flex',
  color: Colors.TextDefault,
  textColor: Colors.TextDefault,
  _hover: {
    textDecoration: 'underline',
  },
};

const textStyle = {
  mr: 2,
};

type Props = {
  to: string;
  onClick?: () => void;
  children?: ReactNode;
  sx?: object;
};

export const ExternalLink = ({ to, children, onClick, sx, ...props }: Props) => {
  return (
    <Box
      as="a"
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      sx={{ ...linkStyle, ...sx }}
      {...props}
    >
      <Text as="span" sx={textStyle}>
        {children}
      </Text>
      <Box
        as="span"
        sx={{
          display: 'inline-block',
          verticalAlign: 'middle',
          whiteSpace: 'nowrap',
          color: Colors.TextDefault,
        }}
      >
        <Icon name={Icon.Name.ArrowDiagonal} />
      </Box>
    </Box>
  );
};
